export default __webpack_public_path__ + "static/1-1a6990f5131429e253eed31276f079a7.jpeg";